import script from "./activityPoster.vue?vue&type=script&setup=true&lang=js"
export * from "./activityPoster.vue?vue&type=script&setup=true&lang=js"

import "./activityPoster.vue?vue&type=style&index=0&id=3d5912ba&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d5912ba"]])

export default __exports__